import { StrictMode } from 'react';
import { registerSW } from 'virtual:pwa-register';
import { createRoot } from 'react-dom/client';
import { MotionGlobalConfig } from 'framer-motion';
import App from './App';
import { i18nReady } from './i18n';
import { initTelemetry } from './lib/telemetry';
import './index.css';

// Observabilidad (VLT-294): errores no capturados → Worker → base. Solo con
// backend real — el modo demo/CI no genera ruido.
initTelemetry();

// PWA (VLT-360): el SW nuevo se activa solo (autoUpdate) y, además, las
// pestañas que quedan abiertas días re-chequean CADA HORA — sin esto, una
// sesión longeva podía seguir viendo la versión vieja indefinidamente.
// Limpia la caché de API que dejaban versiones anteriores del SW (datos de
// clientes en Cache Storage). Idempotente: si no existe, no hace nada.
if ('caches' in window) void caches.delete('vaultex-api').catch(() => {});

registerSW({
  immediate: true,
  onRegisteredSW(_url, reg) {
    if (reg) setInterval(() => void reg.update(), 60 * 60 * 1000);
  },
});

// Movimiento reducido (a11y, 24-sep): el CSS ya corta SUS animaciones con
// prefers-reduced-motion, pero framer-motion no lee esa preferencia solo —
// las tarjetas seguían entrando con fundido y desplazamiento. Ahora, si el
// usuario pide menos movimiento, framer salta directo al estado final (y
// escucha el cambio en vivo). Además vuelve determinista el escaneo axe:
// ningún texto se mide a media opacidad (causa raíz de los a11y «flaky»).
const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
MotionGlobalConfig.skipAnimations = Boolean(reduceMotion?.matches);
reduceMotion?.addEventListener?.('change', (e) => { MotionGlobalConfig.skipAnimations = e.matches; });

// Apply persisted theme before first paint to avoid flash.
const stored = localStorage.getItem('vaultex-theme');
const mode = stored ? (JSON.parse(stored).state?.mode ?? 'dark') : 'dark';
document.documentElement.classList.toggle('dark', mode === 'dark');

// El primer pintado espera al catálogo del idioma guardado (VLT-297 §6):
// para inglés es inmediato; para español, un chunk pequeño — sin destello.
void i18nReady.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
